<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftBase from '../../../../shifts/components/ShiftBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        navItem: {
            label: 'Schedule',
            icon: 'pi pi-user',
            route: '/(app)/schedule/shifts/',
        },
        navConfig: {
            order: 20,
            navHeader: true,
            leftDrawer: true,
        },
        childNavItems: [
            {
                label: 'Shifts',
                route: '/(app)/schedule/shifts/',
            },
            {
                label: 'New Shift',
                route: '/(app)/schedule/shifts.wizard',
            },
            {
                label: 'Activity',
                route: '/(app)/schedule/activity/',
            },
            {
                label: 'Calendar',
                route: '/(app)/schedule/calendar/',
            }
        ],
    }
})
</script>

<template>
  <ShiftBase />
</template>